import { styled } from "@mui/material"
import DialogContent, { DialogContentProps } from "@mui/material/DialogContent"

export const StyledDialogContent = styled(
  DialogContent as React.FC<DialogContentProps>
)`
  padding: 0;
`
